define('views/blocks/CartMobileView',['underscore', 'jquery', 'backbone', 'app','SubView',
        'UrlFactory',
        'template!blocks/cart-mobile', 'InternalLinkView',
        'AddressAutocompleteView','views/blocks/DateTimeSelectorView',
        'template!blocks/checkout/submit',
    ],
    function (_, $, Backbone, app, SubView,
              UrlFactory,
              cartMobileTemplate, InternalLinkView,
              AddressAutocompleteView,DateTimeSelectorView,
              submitTemplate
              ) {

    //
    // Header View
    //

    //
    // le header est un singleton,
    //
    var view, updateDeliveryDelayInterval,
        state = 'closed';

    return Backbone.View.extend(SubView).extend({

        el:'.cart-mobile',
        events: {
            'click .delivery-address-update': 'clickDeleveryAddressUpdate',
            'click .delivery-datetime-update': 'clickDeleveryDatetimeUpdate'
            // 'click .btn-order':'submitCart'
        },
        initialize:function(){
            view = this;
            view.subviews = [];
            view.render();

            var cart = app.getCart();
            view.listenTo(cart, 'change', view.onChange);
            view.listenTo(cart, 'changeContext', view.onChange);
            view.listenTo(cart.getProducts(),'change', view.onAddProduct);

        },

        render:function(ignoreRetemplating){
            var cart = app.getCart();
            view.$el.html(cartMobileTemplate({
                cart: cart,
                buttonHref:UrlFactory.getUrl('cart'),
            }));
            view.onChange();
            view.updateTemplateSubmit();
            InternalLinkView.initializeLinksOfView(view);
        },
        onChange: function () {
            var cart = app.getCart(),
                btnOrder = view.$('.btn-order'),
                btnConfigure = view.$('.btn-configure'),
                delivery = view.$('.delivery');


            if(cart.getPieces() > 0){
                btnOrder.show();

                // Update button
                view.updateTemplateSubmit();

                view.$('.total-price').text(cart.formatPrice());
                if(cart.hasStore()){
                    delivery.show();
                    btnConfigure.hide();
                    view.$('.delivery-address').html(cart.getDisplayAddress().length > 0 ? cart.getDisplayAddress() : t('Veuillez sélectionnez une adresse', 'Cart'));
                    // TODO traduction
                    view.$('.delivery-time').html(t((cart.isVAE() ? "À venir chercher %s" : "Livraison prévue %s"), "Cart", cart.formatDeliveryTimeLabel()));
                }else{
                    delivery.hide();
                    btnConfigure.show();
                }
                state = 'opened';
            }else{
                btnOrder.hide();
                delivery.hide();
                btnConfigure.hide();
                state = 'closed';
            }

            app.set('cartMobileState',state);


            $('main').css({paddingBottom:view.$el.height()});
        },
        templateSubmit:function(){
            var cart = app.getCart(),
                price = cart.formatPrice(),
                unavailable = cart.getProductsIndispo().size();
            return submitTemplate({
                unavailable:unavailable,
                price:price,
                label: app.t('Voir le panier','Cart'),
                href:UrlFactory.getUrl('cart'),
            });
        },
        updateTemplateSubmit: function() {
            var btnOrder = view.$('.btn-order'),
                html = view.templateSubmit();

            btnOrder.html(html);
            InternalLinkView.initializeLinksOfView(view);
        },
        onAddProduct: function(){
            view.$('.btn-order button').addClass('active');
            if(view.btnTimeout){
                clearTimeout(view.btnTimeout);
            }
            view.btnTimeout = setTimeout(function(){
                view.$('.btn-order button').removeClass('active');
            }, 1500);
        },

        toggle:function(visible){
            if(view.visible !== visible){
                view.visible = visible;
                view.$el.toggle(visible == true);
            }
        },
        hide:function(){
            view.toggle(false)
        },
        show:function(){
            view.toggle(true)
        },




        updateDeliveryDelay:function(){
            var cart = app.getCart();
            // TODO : WTF !
            if(!$(document,view.el)){
                //
                return clearInterval(updateDeliveryDelayInterval);
            }
            view.$('.delivery-delay .value').html(cart.formatDeliveryTimeLabel('top-infos')).attr('title',cart.getDeliveryDelay().moment_min.format('LLLL'));
        },

        autoUpdateDeliveryDelay:function(){
            updateDeliveryDelayInterval = setInterval(function(){
                view.updateDeliveryDelay()
            },20*1000);
        },

        clickDeleveryAddressUpdate:function(){
            this.openAddressAutocomplete('all');
        },

        clickDeleveryDatetimeUpdate:function(){
            this.openDatetimeSelector();
        },

        clickSwitchDeleveryType:function(e){
            //
            if($(e.currentTarget).is('.vae')){
                app.getCart().switchToVAE();
            }else{
                app.getCart().switchToVAD();
            }
        },


        openAddressAutocomplete:function(type){
            var view = this,
                addressAutocompleteView = new AddressAutocompleteView({type:type,theme:'modal', ignoreInitialSelection:true, autoSubmit:true});
            view.listenTo(addressAutocompleteView,'complete',view.completeAddressAutocomplete);
            app.displayModal(addressAutocompleteView);
        },

        completeAddressAutocomplete:function(addressAutocompleteView){
            addressAutocompleteView.trigger('close',addressAutocompleteView);
        },

        openDatetimeSelector:function(){
            app.displayModal(new DateTimeSelectorView());
        },

        onDeliveryUpdate:function(){
            this.render();
        },

    });
});
